<div
  *ngIf="hasMoreRatings"
  placement="bottom"
  container="body"
  class="ib profile-skills-list-other-ratings"
  tooltipClass="faux-popover"
  [ngbTooltip]="tooltipContent"
  [attr.aria-label]="ariaLabel"
  role="cell"
  (mouseenter)="togglePopover(hasMoreRatings)"
  (mouseleave)="togglePopover(false)"
  (focus)="togglePopover(hasMoreRatings)"
  (blur)="togglePopover(false)"
  tabindex="0"
  
>
  <!-- Ratings count -->
  <span [textContent]="moreRatingsCount" ></span>
</div>

<!-- Popover list -->
<ng-template #tooltipContent>
  <dgx-tag-rating-signal-popover-content
    [ratings]="completedRatings"
  ></dgx-tag-rating-signal-popover-content>
</ng-template>
